import { useEffect } from "react";
import { signal } from "@preact/signals-react";
import { FormattedMessage as FM } from "react-intl";

import StepProgress from "../components/StepProgress";
import { layoutStaffSupply } from "../models/LayoutStaffSupply";
import Button from "componentsv2/button/Button";
import { useTable } from "storev2/tableStore";
import { useStore } from "storev2/formStore";
import LayoutView from "../layouts/LayoutView";
import StepStart from "./steps/StepStart";
import StepRequest from "./steps/StepRequest";
import StepSignature from "./steps/StepSignature";
import proxy from "api/proxy";
import Dialog from "componentsv2/modal/Dialog";
import { CheckCircleIcon } from "components/Icons";
import FormMessage from "componentsv2/form/FormMessage";

const recId = signal(null);
const currentStep = signal("start");
const openModal = signal(false);
const number = signal(null);
const message = signal(null);
const employeeData = signal(null);
const stepsOrder = ["start", "request", "signature"];
const storeId = "staff.product.product";

function AddRequest() {
  const _layoutStaffSupply = layoutStaffSupply();
  const { updateRecord, records, findRecord, saveForm, deleteRecord, reset } =
    useStore.getState();
  const _record = findRecord(recId.value);
  const { getTable, resetTable } = useTable();

  async function onNext() {
    const valid = validateNextStep();
    if (!valid) {
      message.value = {
        msg: "staff.supply.fields.required",
        type: "error",
      };
      return false;
    }

    let nextStep;

    if (currentStep.value === "start") {
      const created = await createLines();
      if (!created) return;
      nextStep = "request";
    } else if (currentStep.value === "request") {
      nextStep = "signature";
    } else if (currentStep.value === "signature") {
      nextStep = "signature";
      await saveSignature();
    }

    // prevStep.value = currentStep.value;
    currentStep.value = nextStep;
  }

  function validateNextStep() {
    const { validate = [] } = stepsComponents[currentStep.value];
    const store = _record?.store;
    console.log(store, "store");

    if (!store || !validate.length) return true;

    const getValue = (obj, path) =>
      path.split(".").reduce((acc, key) => acc?.[key], obj);

    const missing = validate.filter((field) => !getValue(store, field));
    const isValid = missing.length === 0;
    return isValid;
  }

  async function createLines() {
    const tallas = await proxy.search("product.size", [], ["code"]);
    console.log(tallas);
    console.log(_record, "record");

    if (!_record?.store?.employee) {
      message.value = { msg: "staff.supply.no_employee", type: "error" };
      return false;
    }

    const { records } = getTable(recId.value);
    console.log(records, "records");

    const recForm = findRecord(_layoutStaffSupply.model, recId.value);
    const values = records.filter(
      (val) => val.quantity > 0 && val?.size?.value,
    );
    if (values.length === 0) {
      message.value = {
        msg: "staff.supply.no_product_supplies",
        type: "error",
      };
      return false;
    }

    const newLinesStore = new Map();
    const newLinesActive = [];

    values.forEach((item) => {
      const idRec = -(Date.now() + Math.floor(Math.random() * 1000));

      newLinesActive.push({
        id: idRec,
        product: { name: item?.size?.value?.name, id: item?.size?.value?.id },
        size: { name: item?.size?.name, id: item?.size?.id },
        quantity: item.quantity || 0,
      });

      newLinesStore.set(idRec, {
        id: idRec,
        product: item?.size?.value?.id,
        quantity: item.quantity,
        size: item?.size?.id,
      });
    });

    const linesStore = new Map();
    linesStore.set("create", newLinesStore);

    recForm.active.lines = newLinesActive;
    recForm.store.lines = linesStore;

    return true;
  }

  async function saveSignature() {
    const _record = findRecord(_layoutStaffSupply.model, recId.value);
    const _toStore = { ..._record.store };

    const { data: res, error } = await proxy.saveQuery({
      model: _layoutStaffSupply.model,
      storeRec: _toStore,
      fieldsNames: ["id", "number"],
    });
    console.log("res", res);

    if (_toStore.files?.recipient_signature) {
      await proxy.buttonMethod({
        model: "staff_supply.request",
        method: "done",
        ids: [res[0].id],
      });
    }

    if (res) {
      number.value = res[0].number;
      openModal.value = true;
    }
  }
  // aca va el cambio
  async function saveRecord() {
    const _record = findRecord(_layoutStaffSupply.model, recId.value);
    const valid = validateNextStep();
    if (!valid) {
      message.value = {
        msg: "staff.supply.fields.required",
        type: "error",
      };
      return false;
    }

    const _toStore = { ..._record.store };

    const { data, error } = await proxy.saveQuery({
      model: _layoutStaffSupply.model,
      storeRec: _toStore,
      fieldsNames: ["id", "number"],
    });
    console.log(_toStore, "toStore");
    console.log(data, "data");

    if (_toStore.files?.recipient_signature) {
      await proxy.buttonMethod({
        model: "staff_supply.request",
        method: "done",
        ids: [_record.store.id],
      });
    }

    if (data) {
      number.value = data[0]?.number;
      employeeData.value = null;
      openModal.value = true;
    }
  }

  function handleCloseMessage() {
    message.value = null;
  }

  function onReset() {
    currentStep.value = "start";
    openModal.value = false;
    recId.value = null;
    reset(true);
    resetTable(storeId);
  }

  function onPrev() {
    const currentIndex = stepsOrder.indexOf(currentStep.value);
    if (currentIndex > 0) {
      currentStep.value = stepsOrder[currentIndex - 1];
    }
  }

  const buttonsPrev = {
    name: `${layoutStaffSupply().model}.prev`,
    color: "rose",
    event: onPrev,
  };

  const buttonsNext = {
    name: `${layoutStaffSupply().model}.next`,
    color: "amber",
    event: onNext,
  };

  const buttonsSave = {
    name: `${layoutStaffSupply().model}.save`,
    color: "neutralDark",
    event: currentStep.value === "request" ? saveRecord : onNext,
  };

  const stepsComponents = {
    start: {
      name: "Start",
      buttons: [buttonsNext],
      component: StepStart,
      validate: ["employee"],
    },
    request: {
      name: "Request",
      buttons: [buttonsPrev, buttonsSave, buttonsNext],
      component: StepRequest,
      validate: ["warehouse", "reason"],
    },
    signature: {
      name: "Signature",
      buttons: [buttonsPrev, buttonsSave],
      component: StepSignature,
      validate: ["files.delivery_signature"],
    },
  };

  const Step = stepsComponents[currentStep.value].component;

  useEffect(() => {
    currentStep.value = "start";
    employeeData.value = null;
    recId.value = null;
  }, []);

  function handleViewStore() {
    const storeId = recId.value;
    console.log("=== handleViewStore ===");
    console.log("recId.value:", storeId);

    const tableData = getTable(storeId);
    console.log("tableData (getTable):", tableData);

    const _record = findRecord(_layoutStaffSupply.model, storeId);
    console.log("formStore findRecord:", _record);
    console.log("  active:", _record?.active);
    console.log("  store:", _record?.store);
  }

  return (
    <LayoutView title="Nueva Solicitud Dotación" link="staff_supply/request">
      <button onClick={handleViewStore}>ver store guardado</button>

      <div className="w-full h-full relative">
        <div className="mt-[49px]">
          <StepProgress
            current={currentStep.value}
            onChange={(newStep) => (currentStep.value = newStep)}
          />
        </div>
        <div className="pb-10">
          <Step recId={recId} records={records} employeeData={employeeData} />
        </div>

        <div className="pt-10 pb-3 fixed bottom-0 w-full pointer-events-none bg-gradient-to-t from-neutral-100 via-neutral-100/80 left-10">
          <div className="flex justify-center space-x-[15px] w-full mx-auto pointer-events-auto">
            {stepsComponents[currentStep.value].buttons.map((button, index) => {
              return (
                <Button
                  key={index}
                  color={button.color}
                  content={button.name}
                  size="w-[166px]"
                  // onClick={button.event === "next" ? onNext : onPrev}
                  onClick={button.event}
                  outline={true}
                />
              );
            })}
          </div>
        </div>
      </div>
      <FormMessage message={message} handleClose={handleCloseMessage} />

      <Dialog
        openModal={openModal}
        size="w-[448px]"
        hiddenHeader={true}
        handleClose={() => null}
      >
        <div className="w-full">
          <div className="p-[10px] pt-[11px] flex justify-center space-x-2">
            <h3 className="text-[24px]">
              <FM id="staff.supply.success" />
            </h3>
            <CheckCircleIcon className="size-[30px] fill-current text-[#3ade11FF]" />
          </div>
          <div className="flex justify-between items-center h-[105px] border-y-[1px] border-[#EBEDEF]">
            <span className="mx-auto">Orden de dotación #{number?.value}</span>
          </div>
          <div className="flex justify-center py-[15px]">
            <Button
              onClick={onReset}
              content="staff_supply.btn_accept"
              color="amber"
              size="w-[166px]"
            />
          </div>
        </div>
      </Dialog>
    </LayoutView>
  );
}

export default AddRequest;
